// 📊 Vue d'ensemble V2 — panneau d'état QuickBooks (propriétaire) : connecté / déconnecté, raison FR, action, bouton Reconnecter.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, AlertTriangle, RefreshCw } from 'lucide-react';
import { API_URL } from '@/lib/apiUrl';

export function useDiagnosticQuickBooks(actif) {
  const [diag, setDiag] = useState(null);
  useEffect(() => {
    if (!actif) return;
    axios.get(`${API_URL}/api/quickbooks/diagnostic`).then((r) => setDiag(r.data)).catch(() => setDiag({ connecte: false, raison: 'Diagnostic indisponible', action_requise: 'Réessayer plus tard' }));
  }, [actif]);
  return diag;
}

export function PanneauQuickBooks({ diag }) {
  const navigate = useNavigate();
  if (!diag) return null;
  const fmt = (iso) => (iso ? new Date(iso).toLocaleString('fr-CA', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
  return (
    <div className={`rounded-xl border p-3 flex flex-wrap items-center gap-3 ${diag.connecte ? 'bg-emerald-50 border-emerald-200' : 'bg-amber-50 border-amber-200'}`} data-testid="panneau-quickbooks">
      {diag.connecte ? <CheckCircle2 className="w-5 h-5 text-emerald-600" /> : <AlertTriangle className="w-5 h-5 text-amber-600" />}
      <div className="flex-1 text-sm">
        <p className="font-semibold" data-testid="panneau-quickbooks-etat">QuickBooks {diag.connecte ? 'connecté' : 'déconnecté'}{diag.realm ? ` · entreprise ${diag.realm}` : ''}</p>
        <p className="text-xs text-slate-600">
          Dernière synchro : {fmt(diag.derniere_synchro)} · Jeton valide jusqu'au : {fmt(diag.token_expire)}
          {diag.raison && <span className="text-amber-800" data-testid="panneau-quickbooks-raison"> · {diag.raison}</span>}
        </p>
        {diag.action_requise && <p className="text-xs text-amber-900 mt-0.5" data-testid="panneau-quickbooks-action">{diag.action_requise}</p>}
      </div>
      {!diag.connecte && (
        <button onClick={() => navigate('/quickbooks')} className="px-3 py-1.5 rounded-lg bg-slate-900 text-white text-xs flex items-center gap-1" data-testid="panneau-quickbooks-reconnecter"><RefreshCw className="w-3.5 h-3.5" />Reconnecter</button>
      )}
    </div>
  );
}
